import { useContext } from "react";
import { diagramVersionHoverContext } from "./diagramVersionHoverContext";

export const useVersionHover = () => {
    return useContext(diagramVersionHoverContext)
}
